export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'skill_attribute/create', params)
	},
	update (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'skill_attribute/update', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'skill_attribute/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'skill_attribute/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/SkillAttribute.js